import FormControl from './FormControl';

export default FormControl;
export type { IFormErrorControlProps } from './FormControl';
